import TibiTabContent from './TibiTabContent';
import TabContent from './TabContent';

import { ITabContentWrapper } from 'source/NFR.types';

//renders different variations based on type of content
const TabContentWrapper: React.FC<ITabContentWrapper> = content => {
  if (content) {
    const tibiContent = content.tibi;
    const evurderingContent = content.evurdering;
    if (tibiContent) {
      return <TibiTabContent {...tibiContent} />;
    } else {
      return <TabContent {...evurderingContent} />;
    }
  }
};

TabContentWrapper.displayName = 'TabContentWrapper';

export default TabContentWrapper;
